import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';
import { STORAGE_KEYS } from '@/shared/constants';
// 剧本相关atoms
// 所有剧本的存储atom
export const scriptsAtom = atomWithStorage(STORAGE_KEYS.GAME_SCRIPTS, []);
// 剧本元数据列表（用于列表显示）
export const scriptMetasAtom = atom((get) => {
    const scripts = get(scriptsAtom);
    return scripts.map((script) => ({
        id: script.id,
        name: script.name,
        description: script.description,
        category: script.category,
        tags: script.tags,
        author: script.author,
        createdAt: script.createdAt,
        rating: script.rating,
        playCount: script.playCount,
    }));
});
// 当前选中的剧本ID
export const currentScriptIdAtom = atom(null);
// 当前剧本详情
export const currentScriptAtom = atom((get) => {
    const scriptId = get(currentScriptIdAtom);
    const scripts = get(scriptsAtom);
    return scripts.find((script) => script.id === scriptId) || null;
});
// 剧本搜索和过滤状态
export const scriptSearchAtom = atom('');
export const scriptCategoryFilterAtom = atom('all');
export const scriptSortByAtom = atom('updated');
export const scriptSortOrderAtom = atom('desc');
// 过滤后的剧本列表
export const filteredScriptMetasAtom = atom((get) => {
    const scripts = get(scriptMetasAtom);
    const searchQuery = get(scriptSearchAtom);
    const categoryFilter = get(scriptCategoryFilterAtom);
    const sortBy = get(scriptSortByAtom);
    const sortOrder = get(scriptSortOrderAtom);
    let filtered = scripts;
    // 搜索过滤
    if (searchQuery.trim()) {
        const query = searchQuery.toLowerCase();
        filtered = filtered.filter((script) => script.name.toLowerCase().includes(query) ||
            script.description.toLowerCase().includes(query) ||
            script.author.toLowerCase().includes(query) ||
            script.tags.some((tag) => tag.toLowerCase().includes(query)));
    }
    // 分类过滤
    if (categoryFilter !== 'all') {
        filtered = filtered.filter((script) => script.category === categoryFilter);
    }
    // 排序
    filtered.sort((a, b) => {
        let aValue;
        let bValue;
        switch (sortBy) {
            case 'name':
                aValue = a.name.toLowerCase();
                bValue = b.name.toLowerCase();
                break;
            case 'created':
                aValue = a.createdAt;
                bValue = b.createdAt;
                break;
            case 'updated':
                aValue = a.createdAt; // TODO: 添加 updatedAt 字段
                bValue = b.createdAt;
                break;
            case 'rating':
                aValue = a.rating || 0;
                bValue = b.rating || 0;
                break;
            case 'playCount':
                aValue = a.playCount || 0;
                bValue = b.playCount || 0;
                break;
            default:
                aValue = a.createdAt;
                bValue = b.createdAt;
        }
        if (typeof aValue === 'string' && typeof bValue === 'string') {
            return sortOrder === 'asc'
                ? aValue.localeCompare(bValue)
                : bValue.localeCompare(aValue);
        }
        else {
            return sortOrder === 'asc'
                ? aValue - bValue
                : bValue - aValue;
        }
    });
    return filtered;
});
// 最近使用的剧本IDs
export const recentScriptIdsAtom = atomWithStorage(STORAGE_KEYS.RECENT_SCRIPTS, []);
// 最近使用的剧本列表
export const recentScriptsAtom = atom((get) => {
    const recentIds = get(recentScriptIdsAtom);
    const scripts = get(scriptsAtom);
    return recentIds
        .map((id) => scripts.find((script) => script.id === id))
        .filter((script) => script !== undefined)
        .slice(0, 10); // 最多显示10个
});
// 剧本操作相关的写入atoms
export const addScriptAtom = atom(null, (get, set, script) => {
    const scripts = get(scriptsAtom);
    set(scriptsAtom, [...scripts, script]);
    // 更新最近使用列表
    const recentIds = get(recentScriptIdsAtom);
    const newRecentIds = [script.id, ...recentIds.filter(id => id !== script.id)].slice(0, 10);
    set(recentScriptIdsAtom, newRecentIds);
});
export const updateScriptAtom = atom(null, (get, set, updatedScript) => {
    const scripts = get(scriptsAtom);
    const updatedScripts = scripts.map((script) => script.id === updatedScript.id ? { ...updatedScript, updatedAt: Date.now() } : script);
    set(scriptsAtom, updatedScripts);
});
export const deleteScriptAtom = atom(null, (get, set, scriptId) => {
    const scripts = get(scriptsAtom);
    const filteredScripts = scripts.filter((script) => script.id !== scriptId);
    set(scriptsAtom, filteredScripts);
    // 从最近使用列表中移除
    const recentIds = get(recentScriptIdsAtom);
    set(recentScriptIdsAtom, recentIds.filter(id => id !== scriptId));
    // 如果当前选中的是被删除的剧本，清除选择
    const currentScriptId = get(currentScriptIdAtom);
    if (currentScriptId === scriptId) {
        set(currentScriptIdAtom, null);
    }
});
// 增加剧本播放次数
export const incrementScriptPlayCountAtom = atom(null, (get, set, scriptId) => {
    const scripts = get(scriptsAtom);
    const updatedScripts = scripts.map((script) => script.id === scriptId
        ? { ...script, playCount: (script.playCount || 0) + 1 }
        : script);
    set(scriptsAtom, updatedScripts);
});
